// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cryogonal: PokeData = {
  "id": 615,
  "name": "cryogonal",
  "height": 11,
  "weight": 1480,
  "base_experience": 180,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "bind",
    "mist",
    "ice-beam",
    "aurora-beam",
    "solar-beam",
    "recover",
    "confuse-ray",
    "light-screen",
    "haze",
    "reflect",
    "acid-armor",
    "sharpen",
    "slash",
    "icy-wind",
    "rapid-spin",
    "ancient-power",
    "sheer-cold",
    "night-slash",
    "ice-shard",
    "freeze-dry",
    "laser-focus"
  ],
  "moves": [
    "solar-beam",
    "confuse-ray",
    "reflect",
    "ancient-power",
    "sheer-cold",
    "night-slash",
    "ice-shard",
    "avalanche",
    "chilly-reception",
    "icicle-dagger",
    "ice-punch",
    "hailstorm",
    "aurora-veil"
  ],
  "evolution_chain": {
    "id": 311,
    "item": null,
    "species": [
      {
        "name": "cryogonal",
        "order": 616,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 121,
    "speed": 147,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
